/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import ArrowRight from "@mui/icons-material/ArrowRight";
import {
  Dropdown,
  DropdownMenuItem,
  DropdownNestedMenuItem,
} from "../../Components/Partials/NestedMenu/DropDown";
import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentChartType } from "../../Redux/chartSlice/chartSlice";
import { setCurrentDateComparison } from "../../Redux/dateCompareSlice/dateCompareSlice";
import { setCurrentChartTypePerformance } from "../../Redux/brandPerformanceChartSlice/brandPerformanceChartSlice";
import { updateSalesType } from "../../Redux/twoColumnChartSlice/twoColumnChartSlice";
import { updateVolumeSalesType } from "../../Redux/twoColumnChartSlice/twoColumnChartVolumeSlice";
import FilterIcon from "../../Assets/Assort.svg";
import Tooltip from "@mui/material/Tooltip";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// export const DropDownDashboard = () => {
//   return (
//     <Box>
//       <Dropdown
//         trigger={<Button>File</Button>}
//         menu={[
//           <DropdownNestedMenuItem
//             label="New"
//             rightIcon={<ArrowRight />}
//             menu={[
//               <DropdownMenuItem
//                 onClick={() => {
//                   console.log({ type: "Document", filter: "New" });
//                 }}
//               >
//                 Document
//               </DropdownMenuItem>,
//               <DropdownMenuItem>
//                 <Button
//                   component="label"
//                   sx={{
//                     color: "#000",
//                     textTransform: "none",
//                     fontSize: "1rem",
//                   }}
//                   variant="text"
//                 >
//                   From Markdown file
//                   <input
//                     id="mdInput"
//                     type="file"
//                     accept=".md"
//                     hidden
//                     onChange={(e) => {}}
//                   />
//                 </Button>
//               </DropdownMenuItem>,
//               <DropdownMenuItem>
//                 <Button
//                   component="label"
//                   sx={{
//                     color: "#000",
//                     textTransform: "none",
//                     fontSize: "1rem",
//                   }}
//                   variant="text"
//                 >
//                   From HTML file
//                   <input
//                     id="mdInput"
//                     type="file"
//                     accept=".html"
//                     hidden
//                     onChange={(e) => {}}
//                   />
//                 </Button>
//               </DropdownMenuItem>,
//             ]}
//           />,
//           <DropdownNestedMenuItem
//             label="Save as"
//             rightIcon={<ArrowRight />}
//             menu={[
//               <DropdownMenuItem
//                 onClick={() => {
//                   console.log("clicked");
//                 }}
//               >
//                 Markdown
//               </DropdownMenuItem>,
//               <DropdownMenuItem
//                 onClick={() => {
//                   console.log("clicked");
//                 }}
//               >
//                 Plain HTML
//               </DropdownMenuItem>,
//               <DropdownMenuItem
//                 onClick={() => {
//                   console.log("clicked");
//                 }}
//               >
//                 Styled HTML
//               </DropdownMenuItem>,
//             ]}
//           />,
//           <DropdownNestedMenuItem
//             label="Export"
//             rightIcon={<ArrowRight />}
//             menu={[
//               <DropdownMenuItem
//                 onClick={() => {
//                   console.log("clicked");
//                 }}
//               >
//                 PDF
//               </DropdownMenuItem>,
//               <DropdownMenuItem
//                 onClick={() => {
//                   console.log("clicked");
//                 }}
//               >
//                 Github Gist
//               </DropdownMenuItem>,
//             ]}
//           />,
//         ]}
//       />
//     </Box>
//   );
// };
// DropDownDashboard.jsx

// DropDownDashboard.jsx
/**
 * @function DropDownDashboard
 * @description A dropdown menu with a nested menu for the dashboard page.
 * @param {Object} menuConfig - The configuration for the menu.
 * @returns {ReactElement} - The dropdown menu component.
 */

/**
 * @typedef {Object} MenuConfig
 * @property {string[]} years - The year labels for the date comparison dropdown.
 * @property {string[]} months - The month labels for the date comparison dropdown.
 * @property {string[]} quarters - The quarter labels for the date comparison dropdown.
 * @property {string[]} charts - The chart type labels for the chart type dropdown.
 */
export const DropDownDashboard = ({
  menuConfig,
  local = false,
  name = "",
  salesTypeManager,
  setSalesTypeManager,
  variant = "local",
  triggerSx ,
  defaultLabel,
  onChange,
  value,
}) => {
  const dispatch = useDispatch();
  const currentChartType = useSelector((state) => state.chart.currentChartType);
  const [selectedCategory, setSelectedCategory] = useState(defaultLabel || "Category Filter");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  // Show tooltip on hover, hide on click
  const handleTooltipOpen = () => setTooltipOpen(true);
  const handleTooltipClose = () => setTooltipOpen(false);
  const handleButtonClick = () => setTooltipOpen(false);

  useEffect(() => {
    if (currentChartType) {
      setSelectedCategory(currentChartType);
    }
  }, []);

  // Update selectedCategory when salesTypeManager changes (for TwoColumnChart)
  useEffect(() => {
    if (
      salesTypeManager &&
      (name === "TwoColumnChart" || name === "twoColumnChartVolume")
    ) {
      setSelectedCategory(salesTypeManager);
    }
  }, [salesTypeManager, name]);

  useEffect(() => {
    if (!value || !menuConfig || Object.keys(menuConfig).length === 0) return;
    if (value === "All Market" || value === (defaultLabel || "Category Filter")) {
      setSelectedCategory(defaultLabel || "All Market");
      return;
    }
    for (const [mainLabel, items] of Object.entries(menuConfig)) {
      if (Array.isArray(items) && items.includes(value)) {
        setSelectedCategory(`${mainLabel}: ${value}`);
        return;
      }
    }
    setSelectedCategory(value);
  }, [value, menuConfig, defaultLabel]);

  const emitChartChangeEvent = (chartType) => {
    dispatch(setCurrentChartType(chartType));
  };

  const emitDateCompareChangeEvent = (dateItem) => {
    dispatch(setCurrentDateComparison(dateItem));
  };

  const handleMenuItemClick = (mainLabel, subItem) => {
    const selectedLabel = `${mainLabel}: ${subItem}`;
    setSelectedCategory(selectedLabel); // Update the displayed value

    if (onChange) onChange(subItem);

    if (local === false) {
      const years = menuConfig?.years || [];
      const months = menuConfig?.months || [];
      const quarters = menuConfig?.quarters || [];

      if (
        years.includes(subItem) ||
        months.includes(subItem) ||
        quarters.includes(subItem)
      ) {
        emitDateCompareChangeEvent(subItem);
      } else {
        const combinedLabel = `${mainLabel},${subItem}`;
        emitChartChangeEvent(combinedLabel); // Emit the combined label
      }
    } else {
      if (name == "TwoColumnChart") {
        const combinedLabel = `${mainLabel},${subItem}`;
        // The ref will be updated by the callback function in SortableChart
        console.log(
          "🔍 [DropDownDashboard] Setting TwoColumnChart salesType:",
          combinedLabel
        );
        if (setSalesTypeManager) {
          setSalesTypeManager(combinedLabel);
        } else {
          dispatch(updateSalesType(combinedLabel));
        }
      } else if (name == "twoColumnChartVolume") {
        const combinedLabel = `${mainLabel},${subItem}`;
        // The ref will be updated by the callback function in SortableChart
        console.log(
          "🔍 [DropDownDashboard] Setting TwoColumnVolumeChart salesType:",
          combinedLabel
        );
        if (setSalesTypeManager) {
          setSalesTypeManager(combinedLabel);
        } else {
          dispatch(updateVolumeSalesType(combinedLabel));
        }
      } else {
        const combinedLabel = `${mainLabel},${subItem}`;
        dispatch(setCurrentChartTypePerformance(combinedLabel));
      }
    }
  };

  // Choose style and label based on variant
  const isGlobal = variant === "global";
  const buttonLabel =
    selectedCategory && selectedCategory !== "Category Filters"
      ? selectedCategory
      : isGlobal
      ? "Dashboard Category Filters"
      : defaultLabel || "Category Filter";
  const buttonIcon = isGlobal ? (
    <img src={FilterIcon} alt="Filter" style={{ width: 20, height: 20 }} />
  ) : null;
  const tooltip = isGlobal ? "These filters apply to all charts below" : "";

  return (
    <Box>
      <Dropdown
        trigger={
          isGlobal ? (
            <Tooltip
              title={tooltip}
              arrow
              open={tooltipOpen}
              onOpen={handleTooltipOpen}
              onClose={handleTooltipClose}
              disableFocusListener
              disableTouchListener
            >
              <span>
                <Button
                  startIcon={buttonIcon}
                  onMouseEnter={handleTooltipOpen}
                  onMouseLeave={handleTooltipClose}
                  onClick={handleButtonClick}
                  sx={{
                    background: "#f5f7fa",
                    border: "2px solid #08306B",
                    color: "#08306B",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(25, 118, 210, 0.08)",
                    padding: {
                      xs: "6px 12px",    
                      sm: "8px 16px",    
                      md: "8px 20px",    
                    },
                    height: {
                      xs: "36px",        
                      sm: "38px",        
                      md: "40px",        
                    },
                    fontSize: {
                      xs: "12px",        
                      sm: "13px",        
                      md: "14px",        
                    },
                    minWidth: {
                      xs: "60px",        
                      sm: "65px",        
                      md: "70px",        
                    },
                    textTransform: "none",
                    transition: "background 0.2s, box-shadow 0.2s",
                    "&:hover": {
                      background: "#e3eafc",
                      boxShadow: "0 4px 16px rgba(25, 118, 210, 0.16)",
                    },
                  }}
                >
                  {buttonLabel}
                </Button>
              </span>
            </Tooltip>
          ) : (
            <Button
              endIcon={<ArrowDropDownIcon sx={{ color: "#6C63FF" }} />}
              sx={{
                fontWeight: 500,
                padding: {
                  xs: "4px 12px",     
                  sm: "6px 14px",     
                  md: "6px 16px",     
                },
                marginTop: {
                  xs: "4px",          
                  sm: "6px",          
                  md: "8px",          
                },
                minHeight: {
                  xs: "32px",         
                  sm: "34px",         
                  md: "36px",         
                },
                width: "100%",
                maxWidth: {
                  sm: "275px",        
                  md: "300px",        
                },
                textTransform: "none",
                fontSize: {
                  xs: "11px",         
                  sm: "12px",         
                  md: "13px",         
                },
                display: "inline",
                mx: "auto",
                alignItems: "center",
                gap: 1,
                "& .MuiSelect-icon": { color: "#6C63FF" },
                border: "none",
                boxShadow: "none",
                "&:hover": {
                  color: "#1976d2",
                  background: "none",
                  boxShadow: "none",
                },
                ...triggerSx, 
              }}
            >
              {buttonLabel}
            </Button>
          )
        }
        menu={Object.entries(menuConfig)
          .filter(([key, value]) => value !== null)
          .map(([mainLabel, items], index) => {
            if (mainLabel === "channel" || mainLabel === "retailer") {
              return (
                <DropdownMenuItem key={mainLabel} disabled>
                  {mainLabel}
                </DropdownMenuItem>
              );
            }
            return (
            <DropdownNestedMenuItem
              key={mainLabel}
              label={mainLabel}
              rightIcon={<ArrowRight />}
              menu={items.map((subItem, subIndex) => (
                <DropdownMenuItem
                  key={`${mainLabel}-${subIndex}`}
                  onClick={() => handleMenuItemClick(mainLabel, subItem)} // Pass mainLabel and subItem
                >
                  {subItem}
                </DropdownMenuItem>
              ))}
            />
            );
        })}
      />
    </Box>
  );
};
